import { generateClient } from "aws-amplify/api";
import { batchAddFieldContinuationData } from "../graphql/mutations";
import { FieldContinuationDataForResolver } from "db/definitions";
import { recordSentry } from "utils/recordSentry";

async function batchCreateFieldContinuationData(data: FieldContinuationDataForResolver[]): Promise<boolean> {
	if (data.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchAddFieldContinuationData,
				variables: { continuationdata: data },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchCreateFieldContinuationData;
